<template>
    <div id="Header" class="Penal-bottom">
        <b-navbar>
            <b-navbar-nav>
                <div class="d-flex">
                    <div class="menuIcon" @click="isOpen">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-list" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                        </svg>
                    </div>
                    <b-nav-item-dropdown toggle-class="text-decoration-none  p-0" no-caret offset="25">
                        <template v-slot:button-content>
                            <div class="navText">
                                <img src="../assets/Tasks.png" />
                                <span class="mobile-none">數據圖表</span>
                                <b-icon icon="chevron-down" class="mobile-none"></b-icon>
                            </div>
                        </template>
                        <div class="d-flex">
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                            </div>
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                            </div>
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                            </div>
                        </div>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown toggle-class="text-decoration-none  p-0" no-caret>
                        <template v-slot:button-content>
                            <div class="navText">
                                <img src="../assets/Tasks.png" />
                                <span class="mobile-none">數據圖表</span>
                                <b-icon icon="chevron-down" class="mobile-none"></b-icon>
                            </div>
                        </template>
                        <div class="d-flex">
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網眼鏡</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                            </div>
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡</a>
                            </div>
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網官網官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                            </div>
                        </div>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown toggle-class="text-decoration-none  p-0" no-caret>
                        <template v-slot:button-content>
                            <div class="navText">
                                <img src="../assets/Tasks.png" />
                                <span class="mobile-none">數據圖表</span>
                                <b-icon icon="chevron-down" class="mobile-none"></b-icon>
                            </div>
                        </template>
                        <div class="d-flex">
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                            </div>
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                            </div>
                            <div class="d-flex flex-column  navbar-link-group">
                                <div class="navbar-link-title">大學眼鏡官網</div>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                                <a class="navbar-link-text" href="#">  <img src="../assets/Tasks.png" />大學眼鏡官網</a>
                            </div>
                        </div>
                    </b-nav-item-dropdown>
                </div>
                <div class="picture d-none">
                    <img :src="UserInfo.pictureUrl" alt="Alternate Text" />
                </div>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                UserInfo:''
            }
        },
        mounted() {
            this.$root.$on('bv::dropdown::show', bvEvent => {
                bvEvent.target.style.display = 'block'
                bvEvent.target.style.opacity = 0
                setTimeout(function () {
                    bvEvent.target.style.opacity = 1
                },50)
            })

            this.$root.$on('bv::dropdown::hide', bvEvent => {
                bvEvent.target.style.display = 'none'
            })
        },
        methods: {
            isOpen() {
                this.$store.dispatch('handchangeOpen', true)
            }
        },
        mounted() {
            let storage = JSON.parse(localStorage.getItem("UserInfo"));
            this.UserInfo = storage
        }
    }

</script>
<style>

    .menuIcon{
        display:none;
    }

    .navText {
        font-size: 15px;
        padding: 0px !important;
        display: flex;
        align-items: center;
        justify-content: space-around;
        color: #93959C;
        margin-right: 30px;
    }

    .dropdown.show .navText {
        color: #FCFCFC;
    }

    .b-icon.bi {
        color: #0090FF !important;
        font-size: 12px !important;
    }

    #Header{
        display:none;
    }

    #Header .navbar {
        padding: 30px;
    }

    #Header .nav-item {
        width: 137px;
        justify-content: space-between;
    }

    #Header .navbar-expand .navbar-nav {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    #Header .navbar-expand {
        height: 60px;
        background: #23262B;
        box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
        border-radius: 20px;
    }

    #Header .dropdown-menu {
        transition:.3s;
    }

        #Header .dropdown-menu.show {
            background: #23262B;
            border-radius: 20px;
            border: 0px;
            color: #FCFCFC;
            padding: 30px;
            white-space: nowrap;
            box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
            top: 40px;
        }

    #Header .b-nav-dropdown:first-of-type .dropdown-menu.show {
        left: -30px;
    }

    #Header .navbar-link-group:not(:last-child) {
        padding-right: 30px;
    }

    #Header .navbar-link-title {
        color: #0090FF;
        font-size: 18px;
        text-align: left;
    }

    #Header .navbar-link-text {
        color: #93959C;
        font-size: 15px;
        display: flex;
        align-items: center;
    }

        #Header .navbar-link-text img {
            margin-right: 10px;
        }

        #Header .navbar-link-text:not(:last-child), #Header .navbar-link-title:not(:last-child) {
            padding-bottom: 26px;
        }

    .navbar-nav{
        align-items:center;
    }

    #Header .picture {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid #FB8546;
        overflow: hidden;
        padding: 1px;
    }

        #Header .picture img {
            width: 100%;
            padding: 2px;
            border-radius: 50%;
        }

    @keyframes hidden {
        0% {
            display: none!important
        }
        100% {
            display: block !important
        }
    }

    @keyframes show {
        0% {
            display: block !important
        }

        100% {
            display: none !important
        }
    }

    @media screen and (max-width: 992px) {
        #Header{
            display:block;
        }

        .menuIcon {
            display: flex;
            margin-right: 20px;
            font-size: 26px;
            cursor: pointer;
        }

        .mobile-none {
            display: none !important;
        }

        #Header .nav-item{
            display:none;
        }

    }

   
</style>